module.exports = __webpack_public_path__ + "img/zoosk.9f4a5fa.png";